import http from '@/utils/services/http'

export default {
  find (leilao, lote) {
    return http.get(`/api/patio/leilao/${leilao}?lote=${lote}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/services/patio.js